
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/privacy",
      function () {
        return require("private-next-pages/help/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/privacy"])
      });
    }
  